export const SET_USER = 'SET_USER';
export const SET_ANONYMOUS_USER = 'SET_ANONYMOUS_USER';
export const LOGOUT_USER = 'LOGIN_USER';
export const CHANGE_BALANCE = 'CHANGE_BALANCE';
export const CHANGE_WINDOW = 'CHANGE_WINDOW';
export const FORCE_LOGOUT_USER = 'FORCE_LOGOUT_USER';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';

export function setUser(info, auth, loggedin, role, windows) {
    return { type: SET_USER, info, auth, loggedin, role, windows };
}

export function setAnonymousUser(info, token) {
    return { type: SET_ANONYMOUS_USER, info, token };
}

export function logoutUser() {
    return { type: LOGOUT_USER };
}
export function forceLogoutUser() {
    return { type: FORCE_LOGOUT_USER };
}

export function changeWindow(window) {
    return { type: CHANGE_WINDOW, window };
}
export function changeBalance(data) {
    return { type: CHANGE_BALANCE, data };
}
export function setPermissions(permissions, applet) {
    return { type: SET_PERMISSIONS, permissions, applet };
}